import { Grid, Paper } from "@material-ui/core";
import * as React from "react";
import { SelectInput } from "react-admin";
import { SectionTitle } from "../../../src/Components/SectionTitle";
import { UploadFile } from "../../../src/Components/UploadFile";
import { Separator } from "../../../src/Components/Separator";
import CoreInfoRequestFileGrid from "./CoreInfoRequestFileGrid";
import { CoreInfoRequestReasonType } from "../../../src/Constants/Constant";

export default function CoreInfoRequestFiles(props) {
  return (
    <div>
      <Paper>
        <Grid item>
          {props?.canEdit && (
            <>
              <SelectInput
                source="fileType"
                inputProps={{
                  value: props?.selectedCoreInfoRequestFileType,
                }}
                choices={CoreInfoRequestReasonType?.filter?.(x => x.isFileType)}
                optionText="reasonType"
                optionValue="value"
                fullWidth
                required
                variant="outlined"
                onChange={props?.changeRequestOrderFileType}
              />
              {props?.isFileTypeSelected && (
                <UploadFile
                  label=""
                  multiple={false}
                  onHandleFileExecute={() => props?.onHandleFileExecute()}
                  source="coreinforequestfilerelations"
                  object={{
                    coreInfoRequestId: props?.coreInfoRequestId,
                    coreInfoRequestFileType: props?.selectedCoreInfoRequestFileType,
                  }}
                />
              )}
            </>
          )}
          <Separator />
          <CoreInfoRequestFileGrid
            source="coreinforequestfilerelations"
            filter={{ coreInfoRequestId__eq: props.coreInfoRequestId }}
            showFileType={true}
            canEdit={props?.canEdit}
            trigged={props?.getFileGrid}
            triggeted={() => props?.onFileGridRefresh?.()}
            onFilesChange={props?.onFilesChange}
          />
        </Grid>
      </Paper>
    </div>
  );
}
